//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AnimatedLink from '@/components/common/AnimatedLink.vue'

export default {
  components: {
    AnimatedLink
  },
  props: {
    title: {
      type: String,
      default: null
    },
    bottomText: {
      type: String,
      default: null
    },
    img: {
      type: String,
      default: null
    },
    imgSize: {
      type: String,
      default: 'sm'
    },
    link: {
      type: String,
      default: ''
    },
    linkType: {
      type: String,
      default: 'internal-link'
    }
  }
}
